import * as yup from 'yup';

import {IS_NG} from 'core/constants/env';

const optionalDate = yup
    .date()
    .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
            return null;
        }
        return value;
    })
    .nullable();

const baseLabelValueSchema = yup
    .object({
        label: yup
            .string()
            .nullable()
            .notRequired(),
        value: yup
            .string()
            .nullable()
            .notRequired(),
    })
    .nullable()
    .notRequired();

const optionShape = baseLabelValueSchema.shape({
    city: yup
        .string()
        .nullable()
        .notRequired(),
    country: yup
        .string()
        .nullable()
        .notRequired(),
    postalCode: yup
        .string()
        .nullable()
        .notRequired(),
    street: yup
        .string()
        .nullable()
        .notRequired(),
});

const storageLocationAddressShape = baseLabelValueSchema;

export const generalInfoSchema = yup.object().shape({
    dueDate: optionalDate.when('$IS_NG', {
        is: false,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema,
    }),
    issueDate: optionalDate.required(),
    customerCompanyNameOrTIN: optionShape.required(),
    bic: yup.string(),
    iban: yup.string().required(),
    customerEmail: yup
        .string()
        .email()
        .when('$IS_NG', {
            is: true,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema,
        }),
    customerPhoneNumber: yup.string(),
    storageLocationAddress: yup.string(),
    storageLocationName: storageLocationAddressShape.required(),
});

type ValidationContext = {
    IS_NG: boolean;
};

export const createValidationContext = (): ValidationContext => ({IS_NG});

const resolveFieldSchema = (fieldSchema: any, context: ValidationContext) => {
    if (!fieldSchema) {
        return null;
    }

    if (typeof fieldSchema.resolve === 'function') {
        return fieldSchema.resolve({
            context,
        });
    }

    return fieldSchema;
};

const hasRequiredTest = (schema: any) => {
    if (!schema) {
        return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    const exclusiveTests = schema.exclusiveTests ?? schema._exclusive;
    if (exclusiveTests?.required) {
        return true;
    }

    const tests = schema.tests ?? [];
    return tests.some((test: any) => test?.OPTIONS?.name === 'required');
};

export const createIsFieldRequired = (context: ValidationContext) => {
    const resolvedSchema = generalInfoSchema.resolve({context});

    return (name: string) => {
        const fieldSchema = resolvedSchema.fields[name as keyof typeof resolvedSchema.fields];
        const concreteSchema = resolveFieldSchema(fieldSchema, context);

        return hasRequiredTest(concreteSchema);
    };
};
